import { Stack } from "@compass/core";
import { ReactNode } from "react";

export const SubBar = (props: { width: number; content: ReactNode }) => {
  return (
    <Stack width={props.width} bgcolor={(theme) => theme.palette.background.paper} p={0}>
      {props.content}
    </Stack>
  );
};
